var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlusIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1478_953)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.5 0C20.9558 0 27 6.0442 27 13.5C27 20.9562 20.9558 27 13.5 27C6.04378 27 0 20.9562 0 13.5C0 6.0442 6.04378 0 13.5 0ZM13.5 25.3391C20.0133 25.3391 25.3125 20.0133 25.3125 13.4999C25.3125 6.98662 20.0133 1.68745 13.5 1.68745C6.98667 1.68745 1.6875 6.98665 1.6875 13.4999C1.6875 20.0132 6.98667 25.3391 13.5 25.3391ZM7.59375 12.6562H12.6562V7.59375C12.6562 7.128 13.0343 6.75 13.5 6.75C13.9657 6.75 14.3438 7.128 14.3438 7.59375V12.6562H19.4062C19.872 12.6562 20.25 13.0343 20.25 13.5C20.25 13.9657 19.872 14.3438 19.4062 14.3438H14.3438V19.4062C14.3438 19.872 13.9657 20.25 13.5 20.25C13.0343 20.25 12.6562 19.872 12.6562 19.4062V14.3438H7.59375C7.128 14.3438 6.75 13.9657 6.75 13.5C6.75 13.0343 7.128 12.6562 7.59375 12.6562Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1478_953"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27,
    height: 27,
    fill: "white",
    transform: "matrix(-1 0 0 1 27 0)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusIcon);
export default __webpack_public_path__ + "static/media/plusIcon.3f75455eb1e79b8ad4efb12995abb6c4.svg";
export { ForwardRef as ReactComponent };